import {GET_INDEX_REPORT_NEWS,
  GET_INDEX_CASE_REVIEWS,
  GET_INDEX_CASE_NEWS,
  GET_INDEX_COMPARE} from '../mutiation'
import moment from 'moment'
import { parseUrl } from '@index/assets/js/common.js'

// inital state
const state = {
  news: [],
  newsMore: false,
  reports: [],
  reportsMore: false,
  reviews: [],
  // summary: {
  //   yuqing: `【舆情周期】高层类危机舆情周期平均持续<span style="color: #3989cb;">12.5</span>，热议期持续<span style="color: #3989cb;">3.5</span>天；<span style="color: #3989cb;">30%</span>的高层类危机伴随着次生舆情的发生。`,
  //   action: `【公关动作】此类危机中，公关首次介入时间均值为事件开始后的<span style="color: #3989cb;">49.6</span>小时，其中有<span style="color: #3989cb;">48%</span>的危机在事件开始的24小时内进行了公关回应。整个危机持续周期内，公关平均回应次数为<span style="color: #3989cb;">2</span>次。`,
  //   effect: `【效果评价】公关传播效果指数均值为<span style="color: #3989cb;">44.1</span>分。公关回应后平均负面舆情占比为<span style="color: #3989cb;">73.2%</span>，其中媒体负面舆情占比均值<span style="color: #3989cb;">53.2%</span>，社交媒体负面舆情占比<span style="color: #3989cb;">66.8%</span>。<span style="color: #3989cb;">65%</span>的危机在回应后负面舆情下降。`
  // },
  tags: [],
  colors: ['#429feb', '#36a6c6', '#3bc4dd', '#61a5c2', '#89c2d9', '#3964cb', '#6088e4', '#9bb9fc', '#266eaa', '#3989cb'],
  legends: [],
  events: [],
  total: {
    events: 0,
    brands: 0
  }
}

// actions
const actions = {}

// mutations
const mutations = {
  [GET_INDEX_REPORT_NEWS] (state, data) {
    state.reports = data.reports.map(d => {
      return d
    })
    state.reportsMore = data.hasMore
  },
  [GET_INDEX_CASE_REVIEWS] (state, data) {
    state.reviews = data.map(d => {
      return Object.assign({}, d, {
        time: moment(d.publishTime).format('YYYY/M/D'),
        url: parseUrl(d.url)
      })
    })
  },
  [GET_INDEX_CASE_NEWS] (state, data) {
    state.news = data.events.map(d => {
      let name = `${moment(d.cTime).format('YYYY/M/D')}【预上线】${d.title}`
      let desc = `预计上线时间：${moment(d.onlineTime).format('YYYY/M/D')}`
      if (d.type === 1) {
        name = `${moment(d.onlineTime).format('YYYY/M/D')}【上线】${d.title}`
        desc = `事态严重性${d.crisisLevel}星，公关传播效果评价${d.interveneLevel}`
      }
      return Object.assign({}, d, {
        name: name,
        desc: desc
      })
    })
    state.newsMore = data.hasMore
  },
  [GET_INDEX_COMPARE] (state, data) {
    state.total = {
      events: data.eventCount,
      brands: data.brandCount
    }
    state.tags = data.categories.map(d => {
      return Object.assign({}, d, {
        yuqing: `【舆情周期】${d.category}类危机舆情周期平均持续<span style="color: #3989cb;">${d.avgContinueDay}</span>天，热议期持续<span style="color: #3989cb;">${d.avgHotDay}</span>天；<span style="color: #3989cb;">${d.secondaryPro}</span>的${d.category}类危机伴随着次生舆情的发生。`,
        action: `【公关动作】此类危机中，公关首次介入时间均值为事件开始后的<span style="color: #3989cb;">${d.avgInterveneHour}</span>小时，其中有<span style="color: #3989cb;">${d.quickIntervenePro}</span>的危机在事件开始的24小时内进行了公关回应。整个危机持续周期内，公关平均回应次数为<span style="color: #3989cb;">${d.avgInterveneCount}</span>次。`,
        effect: `【效果评价】公关传播效果指数均值为<span style="color: #3989cb;">${d.avgInterveneScore}</span>分。公关回应后平均负面舆情占比为<span style="color: #3989cb;">${d.avgAfterNeg}</span>，其中媒体负面舆情占比均值<span style="color: #3989cb;">${d.avgAfterNegMedia}</span>，社交媒体负面舆情占比<span style="color: #3989cb;">${d.avgAfterNegWeMedia}</span>。<span style="color: #3989cb;">${d.afterNegDownPro}</span>的危机在回应后负面舆情下降。`
      })
    })
    state.legends = data.categories.map((d, i) => {
      return {
        tag: d.category,
        color: state.colors[i]
      }
    })
    const eventsNew = []
    data.categories.map(a => {
      a.events.forEach(d => {
        eventsNew.push({
          title: d.eventName,
          score: d.interveneScore,
          type: d.category,
          brand: d.brand,
          timeCompare: d.compareContinueHour > 24 ? `${(d.compareContinueHour / 24).toFixed(1)}天` : `${d.compareContinueHour}小时`,
          scoreCompare: `${d.compareInterveneScore}分`,
          scoreCompareZh: d.compareInterveneScoreType,
          timeCompareZh: d.compareContinueHourType,
          id: d.id
        })
      })
    })
    state.events = eventsNew
  }
}

// getters
const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/index/store/modules/subscribe.js